// printUtils.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import PrintableConsignment from '../components/PrintableConsignment';

/**
 * Print a consignment document
 * @param {Object} consignmentData - The consignment data to print
 * @param {String} type - 'LT' for Land Transport or 'D' for Domestic
 */
export const printConsignment = (consignmentData, type = 'LT') => {
  // Create a hidden div for printing
  const printDiv = document.createElement('div');
  printDiv.id = 'print-container';
  printDiv.style.position = 'fixed';
  printDiv.style.top = '0';
  printDiv.style.left = '0';
  printDiv.style.width = '100%';
  printDiv.style.height = '100%';
  printDiv.style.backgroundColor = 'white';
  printDiv.style.zIndex = '9999';
  printDiv.style.overflow = 'auto';
  
  document.body.appendChild(printDiv);

  // Render the printable component
  const root = ReactDOM.createRoot(printDiv);
  root.render(
    <div>
      <div style={{ 
        padding: '20px', 
        textAlign: 'right',
        backgroundColor: '#f5f5f5',
        borderBottom: '2px solid #ddd',
        position: 'sticky',
        top: 0,
        zIndex: 10000
      }} className="no-print">
        <button
          onClick={() => {
            root.unmount();
            document.body.removeChild(printDiv);
          }}
          style={{
            marginRight: '10px',
            padding: '10px 20px',
            backgroundColor: '#6b7280',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          Cancel
        </button>
        <button
          onClick={() => {
            window.print();
          }}
          style={{
            padding: '10px 20px',
            backgroundColor: '#3b82f6',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          🖨️ Print
        </button>
      </div>
      <PrintableConsignment data={consignmentData} type={type} />
    </div>
  );

  // Clean up after printing
  window.addEventListener('afterprint', () => {
    setTimeout(() => {
      try {
        root.unmount();
        if (document.body.contains(printDiv)) {
          document.body.removeChild(printDiv);
        }
      } catch (err) {
        console.error('Error cleaning up print container:', err);
      }
    }, 100);
  }, { once: true });
};

/**
 * Generate a print preview URL for a consignment
 * @param {Object} consignmentData 
 * @param {String} type 
 * @returns {String} - Data URL that can be used to open in new window
 */
export const generatePrintPreview = (consignmentData, type = 'LT') => {
  // This would generate a standalone HTML page for printing
  const htmlContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Consignment ${consignmentData.ConsignmentNo}</title>
      <style>
        /* Include all print styles here */
        body { font-family: Arial, sans-serif; margin: 0; padding: 20px; }
        /* Add more styles as needed */
      </style>
    </head>
    <body>
      <!-- Print content here -->
      <h1>Consignment: ${consignmentData.ConsignmentNo}</h1>
      <button onclick="window.print()">Print</button>
    </body>
    </html>
  `;
  
  return 'data:text/html;charset=utf-8,' + encodeURIComponent(htmlContent);
};

/**
 * Download consignment as PDF (requires additional library like jsPDF or html2pdf)
 * @param {Object} consignmentData 
 * @param {String} type 
 */
export const downloadConsignmentPDF = async (consignmentData, type = 'LT') => {
  // This would use html2pdf.js or similar library
  // For now, just trigger print
  console.log('PDF download would be implemented here');
  printConsignment(consignmentData, type);
};